/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import Dropdown from '@ion/dls/src/components/menus/Dropdown';
import {BulkSCIUpdateProps} from './BulkSCIUpdateDetails';

export const BulkSCIUpdateDeviceType = ({
  selectedSCIDevices,
  selectedSCITypes,
  selectedRowEntities,
  path,
  classes,
  typeOptions,
  onTypeChange,
  deviceTypes
}: BulkSCIUpdateProps) => {
  const getSCIOptions = () => {
    return selectedSCIDevices?.map((type, index) => {
      const value = selectedSCITypes?.find((i, item) => item === index);
      return {
        label : value,
        value
      };
    });
  };

  const SCIOptions = getSCIOptions();
  const SCIType    = deviceTypes?.deviceType;

  return (
    <>
      <div className={classes.dropdown}>
        <Dropdown required
          name={'deviceType'}
          placeholder={translate(`${path}.deviceType`)}
          options={selectedRowEntities?.length ? SCIOptions : typeOptions}
          fieldLabel={translate(`${path}.deviceType`)}
          value={SCIType}
          onChange={onTypeChange}
          defaultValue={SCIType} />
      </div>
    </>
  );
};

export default BulkSCIUpdateDeviceType;
